import dayjs from 'dayjs';

import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import 'dayjs/locale/uk';
import { DateString } from '~shared/types';

dayjs.locale('uk');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(localeData);
dayjs.extend(isBetween);

const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
dayjs.tz.setDefault(userTZ);

export const toUTC = (d: dayjs.Dayjs | string | Date) => {
  return dayjs(d).utc();
};

export const toUTCString = (d: dayjs.Dayjs | string | Date) => {
  return toUTC(d).toISOString();
};

export const fromUTC = (isoString: DateString) => {
  return dayjs.utc(isoString).tz(); // tz() использует userTZ
};

export const formatDate = (
  date?: DateString | null,
  fallbackText = '-',
  format = 'DD.MM.YYYY'
) => (date ? fromUTC(date).format(format) : fallbackText);

export const isValidDateString = (value: unknown): value is string => {
  if (typeof value !== 'string') return false;

  // yyyy-mm-ddTHH:MM:ss.sssZ
  const isoRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z?)?$/;

  if (!isoRegex.test(value)) return false;

  const date = new Date(value);

  return !isNaN(date.getTime());
};

export const daysDiff = (startDate: Date | string, endDate: Date | string) =>
  toUTC(endDate).startOf('day').diff(toUTC(startDate).startOf('day'), 'day');
